import { createSlice } from "@reduxjs/toolkit";

const initialStoreApprovalState = {
    listLoading: false,
    actionsLoading: false,
    resolveLoading: false,
    totalCount: 0,
    entities: [],
    storeApprovalForEdit: undefined,
    approvalStatusList: [],
    lastError: null,
    message: null,
    currentTab: "overview",
    error: null,
};
export const callTypes = {
    list: "list",
    action: "action",
    resolve: "resolve",
};

export const storeApprovalSlice = createSlice({
    name: "storeApprovals",
    initialState: initialStoreApprovalState,
    reducers: {
        catchError: (state, action) => {
            state.error = action.payload.error.clientMessage;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = false;
            } else if (action.payload.callType === callTypes.resolve){
                state.resolveLoading = false;
            } else {
                state.actionsLoading = false;
            }
        },
        startCall: (state, action) => {
            state.error = null;
            state.message = null;

            if (action.payload.callType === callTypes.list) {
                state.listLoading = true;
            } else if (action.payload.callType === callTypes.resolve){
                state.resolveLoading = true;
            } else {
                state.actionsLoading = true;
            }
        },
        endCall: (state, action) => {
            state.error = null;
            state.message = null;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = false;
            } else if (action.payload.callType === callTypes.resolve){
                state.resolveLoading = false;
            } else {
                state.actionsLoading = false;
            }
        },
        // getStoreApprovalById
        storeApprovalFetched: (state, action) => {
            state.actionsLoading = false;
            state.storeApprovalForEdit = action.payload.storeApprovalForEdit;
            state.floorPlans = action.payload.storeApprovalForEdit.floorPlans;
            state.error = null;

        },
        // getStoreApprovalChart
        storeApprovalChartFetched: (state, action) => {

            state.actionsLoading = false;
            state.storeApprovalChart = action.payload.storeApprovalChart;
            state.error = null;

        },
        // getStoreApprovalChart
        storeApprovalHourlyChartFetched: (state, action) => {
            state.actionsLoading = false;
            state.storeApprovalChartHour = action.payload.storeApprovalChartHour;
            state.error = null;

        },
        // getStoreApprovalChart
        storeApprovalHourlyZoneChartFetched: (state, action) => {
            state.actionsLoading = false;
            state.storeApprovalChartHourZone = action.payload.storeApprovalChartHourZone;
            state.error = null;

        },
        // get list data
        storeApprovalsFetched: (state, action) => {
            const { totalCount, entities } = action.payload;
            state.listLoading = false;
            state.error = null;
            state.entities = entities;
            state.totalCount = totalCount;
            state.storeApprovalForEdit = undefined;
            state.floorPlans = undefined;
            state.storeApprovalChart = undefined;
            state.storeApprovalChartHour = undefined;
            state.storeApprovalChartHourZone = undefined;
        },
        // createStoreApproval
        storeApprovalCreated: (state, action) => {
            state.actionsLoading = false;
            state.error = null;
            state.message = action.payload.msgResponse;
        },
        // updateStoreApproval
        storeApprovalUpdated: (state, action) => {
            state.error = null;
            state.actionsLoading = false;
            state.message = action.payload.msgResponse;
        },
        // storeApprovalDeleted
        storeApprovalDeleted: (state, action) => {
            state.error = null;
            state.message = action.payload.msgResponse;
            state.actionsLoading = false;
        },
        storeApporvalStatusFetched: (state,action) => {
            state.error = null;
            state.approvalStatusList = action.payload.approvalStatus;
            state.actionsLoading = false;
        },
        storeResolveApporval : (state,action) => {
            state.error = null;
            state.resolveLoading = false;
            state.message = action.payload.msgResponse;
        },
        setMessage: (state, action) => {
            state.error = null;
            state.message = action.payload.msgResponse;
        },
        setTab: (state, action) => {
            state.error = null;
            state.actionsLoading = false;
            state.currentTab = action.payload.tab;
        },

    }
});
